module.exports = __webpack_public_path__ + "media/images/countrysquared/ax-61f0de4240717527fbeda435251d10e8.svg";